<mat-card class="mat-mdc-card mdc-card cardWithShadow card2 position-relative">
  <mat-card-content class="mat-mdc-card-content p-y-24 text-center">
    <section>
      <img src="../../../../assets/images/discounts-file.jpg" width="200px" height="150px"/>
      <div class="navi">
        <ul>
          <li *ngFor="let factor of factors">
            <button mat-mini-fab class="text-primary bg-light-primary shadow-none rounded">
              <i-tabler name="download" class="routeIcon"></i-tabler>
            </button>
            <a href="{{attachmentsUrl}}{{factor.filePath}}">
              {{ factor.description }}
            </a>
          </li>
        </ul>
      </div>
    </section>
  </mat-card-content>
</mat-card>
